import type { MapHitEvent, MapSurface } from '@gpx-spa/geo-domain';
import { htmlSurface, isPointCloudHit } from '@gpx-spa/geo-domain';
import { shipmentTrackVertexPayload } from '@/map/operational/shipment-track-vertex-payload';
import { formatTrackVertexPopup } from '@/utils/track-vertex-popup';

/** Click-only lazy popup for shipment track point-cloud hits. */
export function trackVertexSurface(event: MapHitEvent): MapSurface | null {
  if (!isPointCloudHit(event)) return null;
  if (event.trigger !== 'click') return null;
  const payload = shipmentTrackVertexPayload(event.target.point.payload);
  if (!payload) return null;
  return htmlSurface(formatTrackVertexPopup(payload), {
    presentation: 'popup',
    dismiss: { closeButton: true, closeOnMapClick: true },
  });
}
